import { api } from '../../../../config/api';
import { callsActions } from '../../actions';
import schema from '../../schemas/callsSchema.json';
import { makeRequestWorker } from '../../../../workers/makeRequestWorker';

export function* getInvitationEmailWorker({ payload }) {
    const options = {
        fetcher: api.calls.getInvitationEmail,
        fetcherParam: payload,
        successAction: callsActions.getInvitationEmailSuccess,
        startFetching: callsActions.getInvitationEmailStartFetching,
        stopFetching: callsActions.getInvitationEmailStopFetching,
        setErrorAction: callsActions.getInvitationEmailError,
        schema,
    };

    yield makeRequestWorker(options);
}
